import { Container } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { ReactBlocks } from 'app/helpers/Blocks'

export interface IAttributes {
  largeDesktopWidth: string
  desktopWidth: string
  tabletWidth: string
  mobileWidth: string
  largeDesktopMargin: string
  desktopMargin: string
  tabletMargin: string
  mobileMargin: string
}

const ContainerBlock: React.FC<IWPGBlock> = (props) => {
  const {
    largeDesktopWidth,
    desktopWidth,
    tabletWidth,
    mobileWidth,
    largeDesktopMargin,
    desktopMargin,
    tabletMargin,
    mobileMargin,
  } = props.attrs as IAttributes

  return (
    <ReactBlocks
      innerBlocks={props.innerBlocks}
      render={(blocks) => (
        <Container
          widths={{
            largeDesktop: Number(largeDesktopWidth ? largeDesktopWidth : 1128),
            desktop: Number(desktopWidth ? desktopWidth : 1096),
            tablet: Number(tabletWidth ? tabletWidth : 1096),
            mobile: Number(mobileWidth ? mobileWidth : 1096),
          }}
          margins={{
            largeDesktop: Number(largeDesktopMargin ? largeDesktopMargin : 0),
            desktop: Number(desktopMargin ? desktopMargin : 128),
            tablet: Number(tabletMargin ? tabletMargin : 48),
            mobile: Number(mobileMargin ? mobileMargin : 48),
          }}
        >
          {blocks}
        </Container>
      )}
    />
  )
}

export default ContainerBlock
